export const IziLanguage = 'izisalonLanguage';